import { brand } from "./theme.js";

/**
 * Tonos de la plataforma (texto + fondo), con la paleta de chips del CRM: fondos
 * claros y texto saturado. Son los mismos que usan los estados de fases y tareas;
 * `color` acepta tanto estos nombres como los colores clásicos.
 */
export const BADGE_TONES = {
  done: { color: "#0F9D58", background: "#E3F6EA" },
  active: { color: brand.pink, background: brand.soft },
  pending: { color: "#FF7A00", background: "#FFE1CE" },
  yellow: { color: "#43380A", background: "#FFF5CE" },
  blocked: { color: "#5F0909", background: "#FFCECE" },
  muted: { color: "#8B8B8F", background: "#F0F0F0" },
  info: { color: "#066CC0", background: "#ECF9FF" },
  purple: { color: "#4535DC", background: "#E7E5FF" },
};

/**
 * Estado de un contenido → etiqueta y tono de `BADGE_TONES`. Única fuente para las
 * tablas, la ficha y el calendario.
 * Borrador gris → Revisión naranja → Aceptado azul → Programado lila → Publicado verde.
 */
export const CONTENT_STATUS_BADGES = {
  draft: { label: "Borrador", color: "muted" },
  client_review: { label: "Revisión", color: "pending" },
  client_approved: { label: "Aceptado", color: "info" },
  scheduled: { label: "Programado", color: "purple" },
  published: { label: "Publicado", color: "done" },
  error: { label: "Con errores", color: "blocked" },
};

/** Texto + fondo del estado, para pintar fuera de un `<Badge>` (calendario). */
export const getContentStatusTone = (status) =>
  BADGE_TONES[CONTENT_STATUS_BADGES[status]?.color] || BADGE_TONES.muted;
